import { GRAD } from "../../../Constants";
import styles from "./SpotDashboard.module.css";

export function VBarChart({ labels, data, gradKey = "green", visibleBars = null }) {
  if (!data.length) {
    return <div className={styles["sd-empty-chart"]}>No data Available</div>;
  }

  const colors = GRAD[gradKey] || GRAD.green;
  const max = Math.max(...data.map(Number), 1) * 1.12;

  const BAR_W = 35;        // increased bar width
  const BAR_GAP = 14;      // increased gap
  const PL = 40;
  const PR = 8;
  const PT = 20;
  const PB = 50;

  const chartW = labels.length * (BAR_W + BAR_GAP) - BAR_GAP;
  const W = chartW + PL + PR;
  const H = 260;

  const visibleChartW = visibleBars
    ? visibleBars * (BAR_W + BAR_GAP) - BAR_GAP
    : chartW;

  const visibleW = visibleChartW + PL + PR;
  const chartH = H - PT - PB;

  return (
    <div
      className={visibleBars ? styles["sd-vbar-center-wrap"] : ""}
      style={{ height: "100%" }}
    >
      <div
        className={visibleBars ? styles["sd-vbar-scroll-wrap"] : ""}
        style={
          visibleBars
            ? {
              width: `${visibleW + 70}px`, // increased scrollbar visible length
              maxWidth: "100%",
              height: "100%",
            }
            : { height: "100%" }
        }
      >
        <svg
          viewBox={`0 0 ${W} ${H}`}
          className={styles["sd-vbar-svg"]}
          style={
            visibleBars
              ? {
                width: `${W}px`,
                minWidth: `${W}px`,
              }
              : undefined
          }
        >
          {[0, 0.25, 0.5, 0.75, 1].map((fraction, index) => (
            <line
              key={index}
              x1={PL}
              y1={PT + (1 - fraction) * chartH}
              x2={W - PR}
              y2={PT + (1 - fraction) * chartH}
              stroke="#ECEDF8"
              strokeWidth="1"
            />
          ))}

          {data.map((rawValue, index) => {
            const value = Number(rawValue || 0);
            const barHeight = (value / max) * chartH;
            const x = PL + index * (BAR_W + BAR_GAP);
            const color = colors[index % colors.length];

            return (
              <g key={`${labels[index]}-${index}`}>
                <text
                  x={x + BAR_W / 2}
                  y={H - PB - barHeight - 5}
                  textAnchor="middle"
                  fontSize="11"
                  fontWeight="600"
                  fill={color}
                >
                  {value}
                </text>

                <rect
                  x={x}
                  y={H - PB - barHeight}
                  width={BAR_W}
                  height={barHeight}
                  fill={color}
                  rx="4"
                />

                <text
                  x={x + BAR_W / 2}
                  y={H - PB + 8}
                  textAnchor="end"
                  fontSize="10"
                  fill="#727271"
                  transform={`rotate(-40,${x + BAR_W / 2},${H - PB + 8})`}
                >
                  {labels[index]}
                </text>
              </g>
            );
          })}
        </svg>
      </div>
    </div>
  );
}